module.exports = __webpack_public_path__ + "img/20190927145113360截图20190927135855430.0467a070.jpg";